import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../store/hooks';
import { fetchMeetings, setHasNew, addUnreadMeeting } from '../store/slices/meetingsSlice';
import { getSocket } from './useSocket';
import { getAccessToken } from '../api/client';
import { useTelegram } from './useTelegram';
export function useNotifications() {
    const dispatch = useAppDispatch();
    const { hapticImpact } = useTelegram();
    const hapticRef = useRef(hapticImpact);
    hapticRef.current = hapticImpact;
    useEffect(() => {
        const token = getAccessToken();
        if (!token)
            return;
        const s = getSocket();
        if (!s.connected)
            s.connect();
        const onIncoming = () => {
            dispatch(setHasNew());
            dispatch(fetchMeetings());
            hapticRef.current('medium');
        };
        const onMessage = (data) => {
            dispatch(setHasNew());
            dispatch(addUnreadMeeting(data.meetingId));
            hapticRef.current('medium');
        };
        s.on('notify:incoming', onIncoming);
        s.on('notify:message', onMessage);
        return () => {
            s.off('notify:incoming', onIncoming);
            s.off('notify:message', onMessage);
        };
    }, [dispatch]);
}
